import React, { ChangeEvent, memo, useCallback } from "react";
import { useSelector } from "react-redux";
import { NumberInput } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { setGrid } from "../../../ducks/print/print";
import { getPrintGridSize } from "../../../ducks/print/selectors";
import { useAction } from "../../../hooks/useAction";
import { clamp } from "../../../utils/math";

const GRID_SIZE_LIMITS = {
  MAX: 2,
  MIN: 0,
};

const GRID_SIZE_STEP = 1;
const clampGridSize = (value: number) => clamp(value || 0, GRID_SIZE_LIMITS.MIN, GRID_SIZE_LIMITS.MAX);

export const GridSizeSetting = memo(() => {
  const { t } = useTranslation("print");
  const updateGrid = useAction(setGrid);
  const gridSize = useSelector(getPrintGridSize);
  const setGridSize = useCallback((size: number) => updateGrid({ size }), [updateGrid]);

  const blurGridSize = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const value = +event.target.value.replace(/\s/g, "");

      setGridSize(clampGridSize(value));
    },
    [setGridSize],
  );

  return (
    <NumberInput
      value={gridSize}
      width={"9.5rem"}
      label={t("gridLinesAppearance")}
      onChange={setGridSize}
      onBlur={blurGridSize}
      counter
      step={GRID_SIZE_STEP}
      min={GRID_SIZE_LIMITS.MIN}
      max={GRID_SIZE_LIMITS.MAX}
    />
  );
});
